import React from "react";
import Layout from "../components/layout";
import Seo from "../components/seo";
import Card from "../components/newComponents/card";
import SectionHead from "../components/newComponents/sectionHead";
import { useQuery } from "@apollo/client";
import { HandleQuery, ResourceListingData } from "../queries";
import { useParams } from "react-router";
import Pagination from "../components/newComponents/pagination";

export function ResourceListing()
{
    let { page } = useParams();
    
    page = parseInt(page ?? 1);
    const perPage = 12;
    const offset = (page - 1) * perPage;

    const query_state = useQuery(ResourceListingData(perPage, offset), {fetchPolicy: 'no-cache'});
    const { complete, view } = HandleQuery(query_state);
    if(!complete) return view;
    const data = query_state.data; 
    const { resources, all } = data;
    const base = "/reports-and-other-documents";
    const nextUrl = Math.ceil(all.length / 12) > page ? `${base}/page/${page + 1}` : null;
    const prevUrl = page > 1 ? page - 1 === 1 ? `${base}` : `${base}/page/${page - 1}` : null;

    return(
  <Layout>
    <Seo title="Reports and other documents" />
    <div className="main">
      <section className="section-boxes section-boxes--news section-boxes--news-secondary">
        <div className="shell">
          <SectionHead title="Reports and other documents" />
          <div className="boxes boxes--news swiper-container js-slider-boxes-news">
            <ul>
              {resources.map((item, i) => (
                <Card 
                  key={`reports-and-other-documents-listing-${i}`} 
                  ar={2} image={item.featureImage[0]} 
                  title={item.displayTitle} 
                  subtitle={item.summary} 
                  href={`/${item.uri}`}
                />
              ))}
            </ul>
            <div className="swiper-pagination boxes__pagination" />
          </div>
          {all.length > 1 &&
            <Pagination nextUrl={nextUrl} prevUrl={prevUrl} currentPage={page} base={base} totalPages={Math.ceil(all.length / 12)}/>
          }
        </div>
      </section>
    </div>
  </Layout>
);
};
